import { render, staticRenderFns } from "./DialogOrderType.vue?vue&type=template&id=5f58c7ce&"
import script from "./DialogOrderType.vue?vue&type=script&lang=js&"
export * from "./DialogOrderType.vue?vue&type=script&lang=js&"
import style0 from "./DialogOrderType.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports